// extracted by mini-css-extract-plugin
module.exports = {"scroll":"horizontal-scroll_scroll__1n6j4"};